import { settingsService } from '../services/settings.service'
import { toastService } from '../services/toast.service'

/** Snapshot current org for async work (upload/consume) started in this tab. */
export function captureOrganizationScope(): number | null {
  return settingsService.getCurrentOrganizationId() ?? null
}

export function isSameOrganizationScope(
  scopeOrganizationId: number | null | undefined,
): boolean {
  const current = settingsService.getCurrentOrganizationId()
  if (scopeOrganizationId == null || current == null) {
    return scopeOrganizationId == null && current == null
  }
  return scopeOrganizationId === current
}

/** Show error toast only if the user is still on the org where the action started. */
export function showErrorIfSameOrganization(
  scopeOrganizationId: number | null | undefined,
  content: string,
  error: unknown = null,
  delay = 10000,
): void {
  if (!isSameOrganizationScope(scopeOrganizationId)) {
    return
  }
  toastService.showError(content, error, delay)
}

/** Show success toast only if the user is still on the org where the action started. */
export function showSuccessIfSameOrganization(
  scopeOrganizationId: number | null | undefined,
  content: string,
  delay = 5000,
): void {
  if (!isSameOrganizationScope(scopeOrganizationId)) {
    return
  }
  toastService.showSuccess(content, delay)
}

/** Show info toast only if the user is still on the org where the action started. */
export function showInfoIfSameOrganization(
  scopeOrganizationId: number | null | undefined,
  content: string,
  delay = 5000,
): void {
  if (!isSameOrganizationScope(scopeOrganizationId)) {
    return
  }
  toastService.showInfo(content, delay)
}
